import React, { useEffect, useState } from "react";
import YouTube from "react-youtube";
import { Container } from "reactstrap";

const videos = [
  { link: "PUB0TaZ7bhA", title: "Trigonometry Basics", topic: "Math" },
  { link: "302eJ3TzJQU", title: "Geometry Basics", topic: "Math" },
  { link: "NybHckSEQBI", title: "Algebra Basics", topic: "Math" },
  { link: "WsQQvHm4lSw", title: "Calculus Basics", topic: "Math" },
  { link: "kjBOesZCoqc", title: "Linear Algebra", topic: "Math" },
  { link: "p_di4Zn4wz4", title: "Differential Equations", topic: "Math" },
  { link: "zOjov-2OZ0E", title: "Introduction to Programming", topic: "CS" },
  { link: "oz9cEqFynHU", title: "Data Structures for Beginners", topic: "CS" },
];

const Videos = () => {
  const [source, setSource] = useState(videos[0].link);
  const active = videos.find((video) => video.link === source) || videos[0];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <main className="relative min-h-[calc(100vh-72px)] overflow-hidden bg-brand-surface">
      <div
        className="pointer-events-none absolute -left-24 top-10 h-72 w-72 animate-soft-pulse rounded-full bg-[radial-gradient(circle,rgba(23,191,158,0.18),transparent_70%)]"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute -right-20 bottom-0 h-80 w-80 animate-soft-pulse rounded-full bg-[radial-gradient(circle,rgba(10,43,30,0.08),transparent_72%)]"
        aria-hidden="true"
      />

      <section className="relative py-10 md:py-14">
        <Container>
          <div className="mb-8 max-w-[560px] animate-fade-up">
            <p className="section-label">Resources</p>
            <h1 className="mb-3 font-display text-[clamp(2rem,4vw,2.8rem)] font-extrabold tracking-tight text-brand-forest">
              Learn with focused video lessons
            </h1>
            <p className="m-0 text-[1.05rem] leading-relaxed text-brand-muted">
              Pick a topic from the list and watch — math foundations through beginner CS.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-5 lg:grid-cols-[1.7fr_1fr]">
            <div className="animate-fade-up-1 overflow-hidden rounded-[22px] border border-brand-forest/10 bg-brand-forest shadow-brand">
              <div className="aspect-video w-full [&_iframe]:h-full [&_iframe]:w-full">
                <YouTube
                  videoId={source}
                  opts={{
                    width: "100%",
                    height: "100%",
                    playerVars: {
                      autoplay: 0,
                      controls: 1,
                      modestbranding: 1,
                      rel: 0,
                    },
                  }}
                  className="h-full w-full"
                  iframeClassName="h-full w-full"
                />
              </div>
              <div className="border-t border-white/10 px-5 py-4">
                <p className="mb-1 font-display text-xs font-semibold uppercase tracking-[0.08em] text-brand-teal">
                  {active.topic}
                </p>
                <h2 className="m-0 font-display text-xl font-bold text-white">
                  {active.title}
                </h2>
              </div>
            </div>

            <div className="animate-fade-up-2 overflow-hidden rounded-[22px] border border-brand-forest/10 bg-white shadow-brand">
              <div className="border-b border-brand-forest/8 px-5 py-4">
                <h3 className="m-0 font-display text-base font-semibold text-brand-forest">
                  Playlist
                </h3>
              </div>
              <ul className="m-0 max-h-[520px] list-none overflow-y-auto p-2">
                {videos.map((video, index) => {
                  const isActive = source === video.link;
                  return (
                    <li key={video.link}>
                      <button
                        type="button"
                        onClick={() => setSource(video.link)}
                        className={`flex w-full items-start gap-3 rounded-xl px-3.5 py-3 text-left transition ${
                          isActive
                            ? "bg-brand-soft text-brand-forest"
                            : "text-brand-muted hover:bg-brand-surface hover:text-brand-forest"
                        }`}
                      >
                        <span
                          className={`mt-0.5 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-lg font-display text-xs font-bold ${
                            isActive
                              ? "bg-brand-teal text-white"
                              : "bg-brand-surface text-brand-muted"
                          }`}
                        >
                          {index + 1}
                        </span>
                        <span className="min-w-0">
                          <span className="block font-display text-sm font-semibold leading-snug">
                            {video.title}
                          </span>
                          <span className="mt-0.5 block font-display text-xs text-brand-muted">
                            {video.topic}
                          </span>
                        </span>
                        {isActive && (
                          <i className="ri-play-circle-fill ml-auto mt-0.5 text-xl text-brand-teal" />
                        )}
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </Container>
      </section>
    </main>
  );
};

export default Videos;
